import React, {useState} from 'react';
import {Form} from 'formik';
import classnames from 'classnames';
import ListUploadedFilesViewDelete from "../ListUploadedFilesViewDelete";
import FormTitle from "../FormTitle";
import FieldInput from 'common/components/FieldInput';
import FieldSelect from 'common/components/FieldSelect';
import FieldDatepicker from 'common/components/FieldDatepicker';
import ButtonsSubmitCancel from '../ButtonsSubmitCancel';
import FieldCheckbox from "../../../../common/components/FieldCheckbox";
import FieldTextareaAutosize from "../../../../common/components/FieldTextareaAutosize";
import UploadingFilePopUp from "../../../../common/components/UploadingFilePopUp/UploadingFilePopUp";
import ButtonTextSuggestions from '../../../../common/components/ButtonTextSuggestions';
import MarkFileUploaded from '../../../../common/components/MarkFileUploaded';
import FieldPasteImage from '../../../../common/components/FieldPasteImage';
import ModalSharedFilesList from '../../../../common/components/ModalSharedFilesList';
import FieldPasteFile from "../../../../common/components/FieldPasteFile";
import {
  limitFloatValueLength,
  limitIntegerValueLength,
  limitValueRangeFloat,
  limitValueRangeInteger
} from "../../../../common/utils/form/limitValueLength";
import GoogleStreetViewImagePopup from "../GoogleStreetViewImagePopup";
import location from "../../../../common/assets/location_on-24px.svg";
import iconOpenInBrowser from "../../../../common/assets/open_in_browser-24px.svg";
import {houseFinishGradeDesc} from "../../constants/textSuggestions";
import styles from './styles.module.scss';

const Form_3View = ({
                      stepID,
                      values,
                      prevPagePath,
                      nextPagePath,
                      options,
                      progress,
                      showUploadingFilePopUp,
                      mapPosition,
                      onFileSelected,
                      fileUploaded,
                      fileTypeIds,
                      filesListData,
                      shumaID,
                      shumaTypeID,
                      setFieldValue,
                      propertyTypes: {
                        isGroundOrLot,
                        isLot,
                        isGround
                      },
                      fileSelectOptions: {
                        buildingFacade,
                        photosVisitDate,
                        propertyDrawing
                      },
                    }) => {
  const googleMapsLink = 'https://www.google.com.ua/maps';
  const [isVisitDateOfficial, setIsVisitDateOfficial] = useState(values.isVisitDateOfficial);

  return (
    <div className={styles.form_3}>
      <FormTitle title={'ביקור בנכס'}/>
      <Form>
        <div className={styles.unit_1}>
          <div className={styles.flexBetween}>
            <div>
              <h3 className={styles.subHeader}>מועד הביקור בנכס</h3>
              <FieldDatepicker
                fieldId="visitDate"
                mandatoryMark={true}
                label={'תאריך ביקור בנכס'}
                containerStyles={styles.marginTop}
              />
            </div>
            <div>
              <h3 className={styles.subHeader}>המועד הקובע לחוו"ד</h3>
              <FieldDatepicker
                fieldId="officialDate"
                mandatoryMark={true}
                label={'תאריך ביקור בנכס/אחר'}
                containerStyles={styles.marginTop}
                disabled={values.isVisitDateOfficial}
              />
            </div>
          </div>
          <FieldCheckbox
            fieldId={'isVisitDateOfficial'}
            value={values.isVisitDateOfficial}
            label={'המועד הקובע לחוו”ד זהה למועד הביקור בנכס'}
            onChange={() => {
              if (!isVisitDateOfficial) setFieldValue('officialDate', values.visitDate);
              setIsVisitDateOfficial(!isVisitDateOfficial);
              setFieldValue('isVisitDateOfficial', !isVisitDateOfficial);
            }}
            containerStyles={styles.marginTop}
          />
        </div>
        <div className={styles.unit_2}>
          <h3 className={styles.subHeader}>פרטי המבקר</h3>
          <div className={classnames(styles.marginTop, styles.marginBottomLow, styles.flexBetween)}>
            <FieldSelect
              fieldId="visitorID"
              placeholder='בחר'
              mandatoryMark={true}
              label={'המבקר'}
              options={options.users}
              containerStyles={styles.halfField}
            />
            <FieldSelect
              fieldId="visitorJob"
              placeholder='בחר אפשרות'
              mandatoryMark={true}
              label={'תפקיד'}
              options={options.visitorJobOptions}
              containerStyles={styles.halfField}
            />
          </div>
        </div>
        <div className={styles.unit_3}>
          <h3 className={styles.subHeader}>פרטי המציג</h3>
          <div className={classnames(styles.marginTopBottom, styles.flexBetween)}>
            <FieldInput
              fieldId="presentorFirstName"
              value={values.presentorFirstName}
              label="שם פרטי"
              containerCustomStyles={styles.halfField}
            />
            <FieldInput
              fieldId="presentorLastName"
              value={values.presentorLastName}
              label="שם משפחה"
              containerCustomStyles={styles.halfField}
            />
          </div>
          {(values.presentorFirstName || values.presentorLastName) &&
            <>
              <div className={classnames(styles.marginTop, styles.marginBottom25, styles.flexBetween)}>
                <FieldSelect
                  fieldId="presentorGender"
                  placeholder='בחר אפשרות'
                  mandatoryMark={true}
                  label={'מגדר'}
                  options={options.presentorGenderOptions}
                  containerStyles={styles.halfField}
                />
                <FieldSelect
                  fieldId="presentorAssociation"
                  placeholder='בחר אפשרות'
                  mandatoryMark={true}
                  label={'זיקה לנכס'}
                  options={options.presentorAssociationOptions}
                  containerStyles={styles.halfField}
                />
              </div>
              <div className={classnames(styles.marginTop, styles.flexBetween)}>
                <FieldSelect
                  fieldId="presentorIdType"
                  placeholder='בחר'
                  mandatoryMark={true}
                  label={'זיהוי המציג ע”י'}
                  options={options.presentorIdTypeOptions}
                  containerStyles={styles.halfField}
                />
                <FieldInput
                  fieldId="presentorIdNumber"
                  value={values.presentorIdNumber}
                  onChange={limitIntegerValueLength(9999)}
                  label={'מספר מזהה'}
                  containerCustomStyles={styles.halfField}
                />
              </div>
            </>
          }
        </div>
        <div className={styles.unit_4}>
          <h3 className={classnames(styles.subHeader, styles.marginTopBottom, styles.flexBetween)}>אכלוס הנכס</h3>
          <FieldSelect
            fieldId="propertyPopulated"
            placeholder='בחר אפשרות'
            mandatoryMark={true}
            label={'האם הנכס מאוכלס'}
            options={options.propertyPopulatedOptions}
            containerStyles={classnames(styles.halfField, styles.marginBottom25)}
          />
          <FieldTextareaAutosize
            fieldId="propertyPopulatedNotes"
            value={values.propertyPopulatedNotes}
            label={'הערות'}
            containerCustomStyles={styles.marginBottomLow}
          />
        </div>
        {(shumaTypeID !== 3 && shumaTypeID !== 4) && (
          <div className={styles.unit_5}>
            <h3 className={classnames(styles.subHeader, styles.marginBottom25)}>קרקע</h3>
            <FieldSelect
              fieldId="landTopography"
              label={'טופוגרפיה'}
              options={options.landTopographyOptions}
              containerStyles={classnames(styles.halfField, styles.marginBottom25)}
            />
          </div>
        )}
        {!isGroundOrLot && (
          <div className={styles.unit_6}>
            <h3 className={styles.subHeader}>הבניין</h3>
            <div className={classnames(styles.flexBetween, styles.marginTopBottom)}>
              <FieldSelect
                fieldId="buildingTypeId"
                options={options.buildingTypeIdOptions}
                label={'סוג הבניין'}
                containerStyles={styles.halfField}
              />
              <FieldSelect
                fieldId="buildingBuildType"
                options={options.buildingBuildTypeOptions}
                mandatoryMark={shumaTypeID !== 1}
                label={'סוג בנייה'}
                containerStyles={styles.halfField}
              />
            </div>
            {(values.buildingBuildType && values.buildingBuildType.value === 3) &&
              <FieldInput
                fieldId="buildingBuildTypeText"
                value={values.buildingBuildTypeText}
                mandatoryMark={true}
                label={'פירוט סוג בנייה'}
                containerCustomStyles={styles.marginBottom25}
              />
            }
            <div className={classnames(styles.marginBottom25, styles.flexBetween)}>
              <FieldSelect
                fieldId="buildingOuterLayer"
                options={options.buildingOuterLayerOptions}
                mandatoryMark={shumaTypeID !== 1}
                label={'חיפוי חיצוני'}
                containerStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="buildingRoofType"
                options={options.buildingRoofTypeOptions}
                mandatoryMark={shumaTypeID !== 1}
                label={'סוג גג'}
                containerStyles={styles.quarterField}
              />
              <FieldInput
                fieldId="buildingAge"
                onChange={limitIntegerValueLength(2)}
                value={values.buildingAge}
                label='גיל הבניין'
                containerCustomStyles={styles.quarterField}
              />
              <FieldInput
                fieldId="buildingEntranceCount"
                value={values.buildingEntranceCount}
                onChange={limitIntegerValueLength(2)}
                mandatoryMark={shumaTypeID !== 1}
                label={'מספר כניסות'}
                containerCustomStyles={styles.quarterField}
              />
            </div>
            {(values.buildingOuterLayer && values.buildingOuterLayer.value === 6) &&
              <FieldInput
                fieldId="buildingOuterLayerText"
                value={values.buildingOuterLayerText}
                mandatoryMark={true}
                label={'פירוט חיפוי חיצוני'}
                containerCustomStyles={styles.marginBottom25}
              />
            }
            <div className={classnames(styles.marginBottom25, styles.flexBetween)}>
              <FieldInput
                fieldId="buildingFloorsCount"
                onChange={limitIntegerValueLength(2)}
                value={values.buildingFloorsCount}
                mandatoryMark={true}
                label={'מספר קומות'}
                containerCustomStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="buildingOnPillars"
                options={options.buildingOnPillarsOptions}
                customIndicatorStyles={styles.customSelectIndicator}
                customSingleValueStyles={styles.customSelectSingleValue}
                mandatoryMark={true}
                label={'מעל קומת'}
                containerStyles={styles.quarterField}
              />
              <FieldInput
                fieldId="apartmentsNumberAtGroundFloor"
                onChange={limitIntegerValueLength(3)}
                value={values.apartmentsNumberAtGroundFloor}
                label={'מספר יח"ד בכניסה'}
                containerCustomStyles={styles.quarterField}
              />
              <FieldInput
                fieldId="apartmentsNumberInBuilding"
                onChange={limitIntegerValueLength(3)}
                value={values.apartmentsNumberInBuilding}
                label={'מספר יח"ד בבניין'}
                containerCustomStyles={styles.quarterField}
              />
            </div>
            {(values.buildingOnPillars && values.buildingOnPillars?.value === 12) && (
              <FieldInput
                fieldId="buildingOnPillarsOtherText"
                value={values.buildingOnPillarsOtherText}
                label={'אחר'}
                containerCustomStyles={styles.marginBottom25}
              />
            )}
            <div className={classnames(styles.marginBottom25, styles.flexBetween)}>
              <FieldInput
                fieldId="buildingApartmentPerFloor"
                value={values.buildingApartmentPerFloor}
                onChange={limitIntegerValueLength(2)}
                mandatoryMark={shumaTypeID !== 1}
                label={'מספר יח"ד בקומה'}
                containerCustomStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="buildingElevator"
                mandatoryMark={true}
                label={'מספר מעליות'}
                options={options.buildingElevatorOptions}
                containerStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="buildingIntercom"
                label={'אינטרקום'}
                options={options.buildingIntercomOptions}
                containerStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="buildingPopulated"
                options={options.buildingPopulatedOptions}
                mandatoryMark={shumaTypeID !== 1}
                label={'האם הבניין מאוכלס'}
                containerStyles={styles.quarterField}
              />
            </div>
            <div
              className={classnames(styles.flexBetween, styles.marginBottom25, {
                [styles.threeQuartersField]: (shumaTypeID !== 3 && shumaTypeID !== 4)
              })}
            >
              <FieldSelect
                fieldId="buildingMaintenance"
                options={options.buildingMaintenanceOptions}
                mandatoryMark={true}
                label={'מצב תחזוקה'}
                containerStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="buildingPhysicalState"
                options={options.buildingPhysicalStateOptions}
                mandatoryMark={true}
                label={(
                  <span>
                  מצב פיזי
                  <span className={styles.topIndex}>(1)</span>
                </span>
                )}
                containerStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="buildingParking"
                options={options.buildingParkingOptions}
                mandatoryMark={true}
                label={'חניה'}
                containerStyles={styles.quarterField}
              />
              {(shumaTypeID === 3 || shumaTypeID === 4) &&
                <FieldSelect
                  fieldId="buildingMatchingEnvironment"
                  options={options.buildingMatchingEnvironmentOptions}
                  label={<span className={styles.customLabel}>האם הבניין תואם/חורג מסביבתו</span>}
                  containerStyles={styles.quarterField}
                />}
            </div>
            <FieldTextareaAutosize
              fieldId="buildingPhysicalStateDesc"
              value={values.buildingPhysicalStateDesc}
              label={'הערות כלליות'}
              containerCustomStyles={styles.marginBottom25}
            />
            {((shumaTypeID === 3 || shumaTypeID === 4) && values.buildingMatchingEnvironment && values.buildingMatchingEnvironment.value === 1) &&
              <FieldTextareaAutosize
                fieldId="buildingMatchingEnvironmentText"
                value={values.buildingMatchingEnvironmentText}
                mandatoryMark={true}
                label={'פירוט חריגה ביחס לסביבה'}
                containerCustomStyles={styles.marginBottom25}
              />
            }
            <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
              <FieldInput
                fieldId="structure"
                value={values.structure}
                label={'מבנה'}
                containerCustomStyles={styles.halfField}
              />
              <FieldInput
                fieldId="buildPercentage"
                value={values.buildPercentage}
                label={'עבור בניין בבניה - אחוז הבניה'}
                onChange={limitValueRangeInteger(2, 0, 99)}
                containerCustomStyles={styles.halfField}
              />
            </div>
            {!isGround && (
              <div className={classnames(
                styles.marginBottom25,
                styles.halfField,
                styles.flexBetween
              )}>
                <FieldInput
                  fieldId="buildingTenantsLicenseCount"
                  onChange={limitIntegerValueLength(3)}
                  value={values.buildingTenantsLicenseCount}
                  label='מספר דיירים ברישוי'
                  containerCustomStyles={styles.quarterField}
                />
                <FieldInput
                  fieldId="buildingTenantsRegisteredCount"
                  onChange={limitIntegerValueLength(3)}
                  value={values.buildingTenantsRegisteredCount}
                  label='מספר דיירים רשום'
                  containerCustomStyles={styles.quarterField}
                />
              </div>
            )}
            <h3 className={classnames(styles.subHeader, styles.marginBottom25)}>
              <span className={styles.mandatoryMark}>*</span>
              <span>תמונת חזית הבניין</span>
            </h3>
            <FieldCheckbox fieldId={'fileType10Switch'} />
            <div className={classnames(styles.flexBetween, styles.googleMapContainer)}>
              <ModalSharedFilesList file={buildingFacade} shumaID={shumaID} stepID={stepID}/>
              <div className={styles.divideLine}/>
              <GoogleStreetViewImagePopup
                address={mapPosition}
                buttonLabel={'הפק'}
                buttonIcon={location}
                buttonClassName={styles.googleMaps}
                onFileApproved={onFileSelected(fileTypeIds.buildingFacade)}
              />
              <div className={styles.divideLine}/>
              <a
                href={googleMapsLink}
                className={styles.googleMapsLink}
                target="_blank" rel="noreferrer"
              >
                <img src={iconOpenInBrowser} className={styles.iconOpenInBrowser} alt="i"/>
                <span>אתר</span>
              </a>
              <div className={styles.divideLine}/>
              <div className={styles.uploadContainer}>
                {!values.fileType10Switch
                  ? (
                    <FieldPasteFile
                      fieldId={'buildingFacadeFileUploaded'}
                      fileUploaded={fileUploaded.buildingFacadeFileUploaded}
                      onFileSelected={onFileSelected(fileTypeIds.buildingFacade)}
                      setFieldValue={setFieldValue}
                    />
                  )
                  : (
                    <FieldPasteImage
                      fieldId={'buildingFacadeFileUploaded'}
                      fileUploaded={fileUploaded.buildingFacadeFileUploaded}
                      onFileSelected={onFileSelected(fileTypeIds.buildingFacade)}
                      setFieldValue={setFieldValue}
                      formFields={'onlyFreeText'}
                    />
                  )
                }
                {fileUploaded.buildingFacadeFileUploaded && <MarkFileUploaded/>}
              </div>
            </div>
            <ListUploadedFilesViewDelete
              data={filesListData}
              fileTypeID={fileTypeIds.buildingFacade}
              shumaId={shumaID}
            />
          </div>
        )}
        <h3 className={classnames(styles.subHeader, styles.marginBottom25)}>הנכס הנבדק</h3>
        {isGround && (
          <div>
            <div className={classnames(styles.marginBottom25, styles.flexBetween)}>
              <FieldSelect
                fieldId="propertyBuildType"
                options={options.buildingBuildTypeOptions}
                label={'סוג בנייה'}
                containerStyles={styles.halfField}
              />
              <FieldSelect
                fieldId="propertyOuterLayer"
                options={options.buildingOuterLayerOptions}
                label={'חיפוי חיצוני'}
                containerStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="propertyRoofType"
                options={options.buildingRoofTypeOptions}
                label={'סוג גג'}
                containerStyles={styles.quarterField}
              />
            </div>
            {(values.propertyBuildType && values.propertyBuildType.value === 3) &&
              <FieldInput
                fieldId="propertyBuildTypeText"
                value={values.propertyBuildTypeText}
                label={'פירוט סוג בנייה'}
                containerCustomStyles={styles.marginBottom25}
              />
            }
            {(values.propertyOuterLayer && values.propertyOuterLayer.value === 6) &&
              <FieldInput
                fieldId="propertyOuterLayerText"
                value={values.propertyOuterLayerText}
                label={'פירוט חיפוי חיצוני'}
                containerCustomStyles={styles.marginBottom25}
              />
            }
            <div className={classnames(styles.marginBottom25, styles.threeQuartersField, styles.flexBetween)}>
              <FieldInput
                fieldId="propertyAge"
                value={values.propertyAge}
                label={'גיל הנכס'}
                containerCustomStyles={styles.quarterField}
              />
              <FieldInput
                fieldId="propertyFloorsCount"
                value={values.propertyFloorsCount}
                onChange={limitIntegerValueLength(2)}
                label={'מספר קומות'}
                containerCustomStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="propertyOnPillars"
                options={options.buildingOnPillarsOptions}
                label={'מעל קומת'}
                containerStyles={styles.quarterField}
              />
            </div>
            {(values.propertyOnPillars && values.propertyOnPillars?.value === 12) && (
              <FieldInput
                fieldId="propertyOnPillarsOtherText"
                value={values.propertyOnPillarsOtherText}
                label={'אחר'}
                containerCustomStyles={styles.marginBottom25}
              />
            )}
          </div>
        )}
        {!isLot && (
          <div>
            <div className={classnames(styles.flexBetween, styles.marginTopBottom)}>
              <FieldInput
                fieldId="houseRoomCount"
                onChange={limitValueRangeFloat(4, 0, 99.9)}
                value={values.houseRoomCount}
                mandatoryMark={true}
                label={'מספר חדרים'}
                containerCustomStyles={styles.quarterField}
              />
              <FieldInput
                fieldId="houseExistingArea"
                onChange={limitFloatValueLength(6)}
                value={values.houseExistingArea}
                label={(
                  <div>
                    שטח קיים
                    <span className={styles.topIndex}> (2)</span>
                  </div>
                )}
                containerCustomStyles={styles.quarterField}
              />
              <FieldInput
                fieldId="houseBalconyOpenArea"
                onChange={limitFloatValueLength(6)}
                value={values.houseBalconyOpenArea}
                label={<span className={styles.textNowrap}>שטח קיים מרפסות פתוחות</span>}
                containerCustomStyles={styles.quarterField}
              />
              <FieldInput
                fieldId="houseBalconyClosedArea"
                onChange={limitFloatValueLength(6)}
                value={values.houseBalconyClosedArea}
                label={<span className={styles.textNowrap}>שטח קיים מרפסות סגורות</span>}
                containerCustomStyles={styles.quarterField}
              />
            </div>
            <FieldTextareaAutosize
              fieldId="houseFunctionalDivide"
              value={values.houseFunctionalDivide}
              mandatoryMark={true}
              label={'חלוקה פונקציונלית'}
              containerCustomStyles={styles.marginBottom25}
            />
            <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
              <FieldSelect
                fieldId="housePhysicalState"
                mandatoryMark={true}
                label={(
                  <span>
                    מצב פיזי
                    <span className={styles.topIndex}>(3)</span>
                  </span>
                )}
                options={options.housePhysicalStateOptions}
                containerStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="houseFinishGrade"
                mandatoryMark={true}
                label={'רמת גמר'}
                options={options.houseFinishGradeOptions}
                containerStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="houseMaintenanceStatus"
                mandatoryMark={true}
                label={'מצב תחזוקה'}
                options={options.houseMaintenanceStatusOptions}
                containerStyles={styles.quarterField}
              />
              <FieldSelect
                fieldId="houseSecureRoom"
                mandatoryMark={true}
                label={'ממ"ד'}
                options={options.houseSecureRoomOptions}
                containerStyles={styles.quarterField}
              />
            </div>
            <FieldTextareaAutosize
              fieldId="houseMaintenanceStatusText"
              value={values.houseMaintenanceStatusText}
              mandatoryMark={values.houseMaintenanceStatus && values.houseMaintenanceStatus.value === 2}
              label={'פירוט מצב תחזוקתי'}
              containerCustomStyles={styles.marginBottom25}
            />
            {!isGround && (
              <FieldInput
                fieldId="houseFloorInBuilding"
                value={values.houseFloorInBuilding}
                label={'קומת הדירה בבניין'}
                containerCustomStyles={styles.marginBottom25}
              />
            )}
            <FieldTextareaAutosize
              fieldId="houseFinishGradeDesc"
              value={values.houseFinishGradeDesc}
              label={
                <div>
                  <span>פירוט רמת גמר</span>
                  <ButtonTextSuggestions
                    fieldName={'houseFinishGradeDesc'}
                    currentFieldValue={values.houseFinishGradeDesc}
                    textSuggestionsArray={houseFinishGradeDesc}
                    setFieldValue={setFieldValue}
                  />
                </div>
              }
              containerCustomStyles={styles.marginBottom25}
            />
            {!isGround && (
              <div className={classnames(
                styles.marginBottom25,
                styles.flexBetween,
                styles.halfField,
                styles.alignEnd
              )}>
                {(shumaTypeID === 3 || shumaTypeID === 4) && (
                  <FieldSelect
                    fieldId="houseMatchingBuilding"
                    options={options.houseMatchingBuildingOptions}
                    label={'האם הדירה חורגת/תואמת את הבנוי בבניין'}
                    containerStyles={styles.quarterField}
                  />
                )}
                <FieldSelect
                  fieldId="buildingLocation"
                  label='מיקום הדירה'
                  options={options.buildingLocationOptions}
                  containerStyles={styles.quarterField}
                />
              </div>
            )}
            {((shumaTypeID === 3 || shumaTypeID === 4) && values.houseMatchingBuilding && values.houseMatchingBuilding.value === 2) &&
              <FieldTextareaAutosize
                fieldId="houseMatchingBuildingText"
                value={values.houseMatchingBuildingText}
                mandatoryMark={true}
                label={'פירוט חריגה ביחס לבניין'}
                containerCustomStyles={styles.marginBottom25}
              />
            }
            <FieldTextareaAutosize
              fieldId="propertyGeneralNotes"
              value={values.propertyGeneralNotes}
              label={'הערות כלליות'}
              containerCustomStyles={styles.marginBottom25}
            />
            <h4 className={styles.marginBottomLow}>כיווני אוויר</h4>
            <div className={classnames(styles.flex, styles.marginBottom25)}>
              <FieldCheckbox
                fieldId="houseAirDirectionNorth"
                label="צפון"
                value={values.houseAirDirectionNorth}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
              <FieldCheckbox
                fieldId="houseAirDirectionSouth"
                label="דרום"
                value={values.houseAirDirectionSouth}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
              <FieldCheckbox
                fieldId="houseAirDirectionEast"
                label="מזרח"
                value={values.houseAirDirectionEast}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
              <FieldCheckbox
                fieldId="houseAirDirectionWest"
                label="מערב"
                value={values.houseAirDirectionWest}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
            </div>
            <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
              <FieldCheckbox
                fieldId="houseAirDirectionNorthEast"
                label="צפון - מזרח"
                value={values.houseAirDirectionNorthEast}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
              <FieldCheckbox
                fieldId="houseAirDirectionNorthWest"
                label="צפון - מערב"
                value={values.houseAirDirectionNorthWest}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
              <FieldCheckbox
                fieldId="houseAirDirectionSouthEast"
                label="דרום - מזרח"
                value={values.houseAirDirectionSouthEast}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
              <FieldCheckbox
                fieldId="houseAirDirectionSouthWest"
                label="דרום - מערב"
                value={values.houseAirDirectionSouthWest}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
            </div>
            <h4 className={styles.marginBottomLow}>נוספים</h4>
            <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
              <FieldCheckbox
                fieldId="houseYard"
                label="חצרות/גינה"
                value={values.houseYard}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeft20)}
              />
              <FieldCheckbox
                fieldId="houseParking"
                label="חניה"
                value={values.houseParking}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
              <FieldCheckbox
                fieldId="houseStorage"
                label="מחסן"
                value={values.houseStorage}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
              <FieldCheckbox
                fieldId="houseRoof"
                label="גג"
                value={values.houseRoof}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
              <FieldCheckbox
                fieldId="houseOther"
                label="אחר"
                value={values.houseOther}
                containerStyles={classnames(styles.checkboxWidth, styles.paddingLeftCheckboxLarge)}
              />
            </div>
            <div className={styles.moreInfo_additionalFields}>
              {values.houseYard &&
                <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
                  <FieldInput
                    fieldId="houseYardArea"
                    onChange={limitFloatValueLength(6)}
                    value={values.houseYardArea}
                    mandatoryMark={true}
                    label={'שטח חצר'}
                    containerCustomStyles={styles.quarterField}
                  />
                  <FieldSelect
                    fieldId="houseYardAffective"
                    mandatoryMark={true}
                    label={'אפקטיבית'}
                    options={options.houseYardAffectiveOptions}
                    containerStyles={styles.quarterField}
                  />
                  <FieldSelect
                    fieldId="houseYardType"
                    mandatoryMark={true}
                    label={'סוג חצר'}
                    options={options.houseYardTypeOptions}
                    containerStyles={styles.halfField}
                  />
                </div>
              }
              {values.houseParking &&
                <div className={classnames(styles.flexBetween, styles.quarterField, styles.marginBottom25)}>
                  <FieldSelect
                    fieldId="houseParkingType"
                    mandatoryMark={true}
                    label={'סוג חניה'}
                    options={options.houseParkingTypeOptions}
                  />
                </div>
              }
              {values.houseStorage &&
                <div className={classnames(styles.flexBetween, styles.halfField, styles.marginBottom25)}>
                  <FieldInput
                    fieldId="houseStorageArea"
                    onChange={limitFloatValueLength(6)}
                    value={values.houseStorageArea}
                    mandatoryMark={true}
                    label={'שטח מחסן'}
                    containerCustomStyles={styles.quarterField}
                  />
                  <FieldSelect
                    fieldId="houseStorageType"
                    mandatoryMark={true}
                    label={'סוג מחסן'}
                    options={options.houseStorageTypeOptions}
                    containerStyles={styles.quarterField}
                  />
                </div>
              }
              {values.houseRoof &&
                <div className={classnames(
                  styles.flexBetween,
                  styles.threeQuartersField,
                  styles.marginBottom25
                )}>
                  <FieldInput
                    fieldId="houseRoofArea"
                    onChange={limitFloatValueLength(6)}
                    value={values.houseRoofArea}
                    mandatoryMark={true}
                    label={'שטח גג'}
                    containerCustomStyles={styles.quarterField}
                  />
                  <FieldSelect
                    fieldId="houseRoofAccess"
                    mandatoryMark={true}
                    label={'גישה'}
                    options={options.houseRoofAccessOptions}
                    containerStyles={styles.halfField}
                  />
                </div>
              }
              {values.houseOther &&
                <FieldTextareaAutosize
                  fieldId="houseOtherText"
                  value={values.houseOtherText}
                  mandatoryMark={true}
                  label={'פירוט אחר'}
                  containerCustomStyles={styles.marginBottom25}
                />
              }
            </div>
          </div>
        )}
        <div>
          <h4 className={classnames(styles.subHeader, styles.marginBottomLow)}>
            <span className={styles.mandatoryMark}>*</span>
            <span>תמונות מיום הביקור</span>
          </h4>
          <div className={classnames(styles.flex, styles.alignCenter)}>
            <ModalSharedFilesList file={photosVisitDate} shumaID={shumaID} stepID={stepID}/>
            <div className={styles.divideLine}/>
            <div className={styles.uploadFilesUnit}>
              {fileUploaded.visitDatePhotoFileUploaded && <MarkFileUploaded/>}
              <FieldPasteImage
                fieldId="visitDatePhotoFileUploaded"
                fileUploaded={fileUploaded.visitDatePhotoFileUploaded}
                onFileSelected={onFileSelected(fileTypeIds.photosVisitDate)}
                setFieldValue={setFieldValue}
                formFields={'freeTextAndFloors'}
              />
            </div>
          </div>
          <ListUploadedFilesViewDelete
            data={filesListData}
            fileTypeID={fileTypeIds.photosVisitDate}
            shumaId={shumaID}
          />
          <h4 className={classnames(styles.subHeader, styles.marginBottomLow)}>שרטוט הנכס</h4>
          <FieldCheckbox fieldId={'fileType33Switch'}/>
          <div className={classnames(styles.flex, styles.alignCenter)}>
            <ModalSharedFilesList file={propertyDrawing} shumaID={shumaID} stepID={stepID}/>
            <div className={styles.divideLine}/>
            <div className={styles.uploadFilesUnit}>
              {fileUploaded.propertyDrawingFileUploaded && <MarkFileUploaded/>}
              {!values.fileType33Switch
                ? (
                  <FieldPasteFile
                    fieldId="propertyDrawingFileUploaded"
                    fileUploaded={fileUploaded.propertyDrawingFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.propertyDrawing)}
                    setFieldValue={setFieldValue}
                  />
                )
                : (
                  <FieldPasteImage
                    fieldId="propertyDrawingFileUploaded"
                    fileUploaded={fileUploaded.propertyDrawingFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.propertyDrawing)}
                    setFieldValue={setFieldValue}
                    formFields={'onlyFreeText'}
                  />
                )
              }
            </div>
          </div>
          <ListUploadedFilesViewDelete
            data={filesListData}
            fileTypeID={fileTypeIds.propertyDrawing}
            shumaId={shumaID}
          />
        </div>
        <div className={styles.refs}>
          <div className={styles.reference}><span className={styles.topIndex}>(1)</span> חוות דעת זו אינה
            מהווה חוו"ד דעת הנדסית ואין
            להסתמך עליה
            כראייה למצבו הפיזי של המבנה.
          </div>
          <div className={styles.reference}><span className={styles.topIndex}>(2)</span> גבולות השטח ומימדיו
            יקבעו ע"י מודד מוסמך (לא
            בתחום סמכותו של
            שמאי מקרקעין)
          </div>
          <div className={styles.reference}><span className={styles.topIndex}>(3)</span> חוות דעת זו אינה
            תחליף לחוו"ד אדריכלית. בחו"ד זו
            לא נבדקו גובה
            המבנה, קווי בניין והעמדה , המצויים בתחום המומחיות של מודד מוסמך.
          </div>
        </div>
        <ButtonsSubmitCancel prevPagePath={prevPagePath} nextPagePath={nextPagePath}/>
      </Form>
      <UploadingFilePopUp
        showUploadingFilePopUp={showUploadingFilePopUp}
        progress={progress}
        message="הקובץ נטען, אנא המתינו"
      />
    </div>
  );
};

export default Form_3View;